import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Modal } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import Color from '@tool/color';
import { ShowEyeIcon, CloseIcon20, DragIcon, HideEyeIcon } from '@styled/icon';
import { newRate } from '@tool/index';
import { Sortable, Icon } from 'zent';
import '../scss/change-item.scss';
import moChange, { onSave, onCancel } from '../store/change';
import moSalary from '../store/salary';

interface IProps {}
interface IState {}

const ChangeItem = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { modelList, checkModel } = moChange;
  const { collectionListAll, collectionOverview, historyListAll, historyOverview, guessListAll, guessOverview } = moSalary;
  const [conList, setConList] = useState<any>([]);

  // 拖动排序

  const handChange = (list: any) => {
    setConList(list);
  };

  // 展示和隐藏眼睛
  const eyeShow = (i: number, r: number) => {
    const result = conList?.map((item: any, e: any) => {
      const items: any = { ...item };
      if (e === i) {
        const child = items.child?.map((res: any, p: any) => {
          const ele = { ...res };
          if (p === r) {
            ele.show = !res.show;
          }
          return ele;
        });
        items.child = child;
      }
      return items;
    });
    setConList(result);
  };

  useEffect(() => {
    setConList(modelList);
    return () => {};
  }, [modelList]);

  return (
    <Modal
      open={checkModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <section className="dash-change-warp">
        <section className="item-top">
          <h3>页面模块设置</h3>
          <span>拖动卡片，调整模块顺序</span>
        </section>
        <Sortable items={conList} onChange={handChange}>
          {conList?.map((item: any, i: any) => {
            return (
              <section key={item.name} className="sort-item">
                <DragIcon />
                <section className="item-content">
                  <h3>{item.name}</h3>
                  <section className="show-model">
                    <b>显示/隐藏模块：</b>
                    {item.child.map((res: any, r: any) => {
                      if (res.name === '猜你关注' && isEmpty(guessListAll)){
                        return '';
                      }
                      if (res.name === '我的收藏' && isEmpty(historyListAll) && isEmpty(collectionListAll)){
                        return '';
                      }
                      return (
                        <span
                          key={res.name}
                          style={{
                            color: res.show ? Color.primary : Color.c87,
                          }}
                          onClick={() => {
                            eyeShow(i, r);
                          }}>
                          {res.show ? (
                            <ShowEyeIcon
                              width={12}
                              height={8}
                              color={Color.primary}/>
                          ) : (
                            <HideEyeIcon
                              width={12}
                              height={8}
                              color={Color.c87}/>
                          )}
                          &nbsp;
                          {res.name}
                        </span>
                      );
                    })}
                  </section>
                </section>
              </section>
            );
          })}
        </Sortable>
        <section className="change-btn">
          <section
            className="canok"
            onClick={() => {
              onSave(conList);
            }}>
            保存修改
          </section>
          <section className="cancel" onClick={onCancel}>
            取消
          </section>
        </section>
      </section>
    </Modal>
  );
};

export default observer(ChangeItem);
